import * as angular from 'angular';

import { DatasourceMetadata } from './db-help-panel-component';
import { getAppName } from '@mode/shared/util-js';

class DirectConnectController {
  readonly appName = getAppName();
  private datasource: DatasourceMetadata[];

  static $inject = [];
  constructor() {}
}

const DirectConnectComponent: angular.IComponentOptions = {
  controller: DirectConnectController,
  controllerAs: 'ctrl',
  bindings: {
    datasource: '<',
  },
  template: `
    <div ng-if="ctrl.datasource.firewallConfigSuggested" class="provider-block">
      <h2 class="help-panel-title">Getting connected</h2>
      <p class="help-panel-text">In order to ensure {{ctrl.appName}} has access to your {{ ctrl.datasource.datasourceName }} database,
      please make sure your firewall is configured to allow the connections from these {{ ctrl.appName == "Analyst Studio" ? "nine" : "eight" }} IP addresses:</p>
      <div ng-if="ctrl.appName === 'Analyst Studio'">
        <p><pre class="ip-block">18.219.18.49/32</br>3.20.219.67/32</br>3.130.46.196/32</br>18.190.82.112/32</br>18.219.27.193/32</br>18.224.75.176/32</br>3.143.83.15/32</br>3.22.39.190/32</br>52.15.221.243/32</pre></p>
      </div>
      <div ng-if="ctrl.appName !== 'Analyst Studio'">
        <p><pre class="ip-block">54.68.45.3/32</br>54.68.30.98/32</br>34.209.23.118/32</br>54.188.241.100/32</br>52.43.195.103/32</br>3.224.146.111/32</br>54.221.238.89/32</br>52.20.173.236/32</pre></p>
      </div>
    </div>

    <div ng-if="ctrl.datasource.isBridged && ctrl.datasource.tlsSupported && ctrl.datasource.tlsOptional" class="provider-block">
      <h2 class="help-panel-title">What is transport encryption?</h2>
      <p class="help-panel-text">Transport encryption is how our system works with yours to keep data
      secure. By default, the connection from {{ctrl.appName}} to your databases is encrypted end-to-end. In some cases
      end-to-end encryption is not possible because transport encryption is not configured or supported by
      your database. If you're unable to enable transport encryption on the database, you can choose to disable
      encryption between {{ctrl.appName}} and your database.</p>
    </div>
  `,
};

angular.module('mode.components').component('directConnect', DirectConnectComponent);
